export const Colors = {
  RED: '#E60028',
  BLACK: '#231F20',
  WHITE: '#FFFFFF',
  SubTextGREY: '#A6A8A8',
  lightGREY: '#e7eaeb',
  successGreen: '#00aa0c',
  primary: '#DD3724',
};
